import { PlaceholderSimpleCard } from 'components/PlaceholderSimpleCard';
import { useFetchQueueCard } from 'components/Player/AudioPlayerWrapper/useFetchQueueCard';
import {
  useTrackCardClick,
  useViewUuid,
} from 'components/SnowplowEngagementAnalytics/hooks';
import { useSnowplow } from 'contexts/SnowplowContext';
import { UserQueueItem } from 'contexts/PlayerStateContext/UserQueueItem';
import { trackPlayQueueItemView } from 'services/snowplowAnalytics/snowplowAnalytics';
import { useEffect, useRef } from 'react';
import { SimpleQueueCard } from './SimpleQueueCard/SimpleQueueCard';

type Props = {
  item: UserQueueItem;
  isSortable: boolean;
  isCheckboxSelected: boolean;
  play: () => void;
  setCheckboxSelected: (value: boolean) => void;
};

export const PlayQueueCard = ({
  isCheckboxSelected,
  isSortable,
  item,
  play,
  setCheckboxSelected,
}: Props) => {
  const cardByItemId = useFetchQueueCard(item.programId);
  const { isSnowplowReady } = useSnowplow();
  const viewUuid = useViewUuid();
  const { trackPlayButtonClick } = useTrackCardClick(viewUuid);
  const ref = useRef<HTMLDivElement>(null);
  const hasTrackedView = useRef(false);

  useEffect(() => {
    const node = ref.current;
    if (!node || !cardByItemId || !isSnowplowReady) return;

    const observer = new IntersectionObserver(([entry]) => {
      if (!entry?.isIntersecting || hasTrackedView.current) return;

      hasTrackedView.current = true;
      trackPlayQueueItemView(viewUuid, item.programId);
      observer.disconnect();
    });

    observer.observe(node);

    return () => {
      observer.disconnect();
    };
  }, [cardByItemId, isSnowplowReady, item.programId, viewUuid]);

  if (!cardByItemId) {
    return <PlaceholderSimpleCard />;
  }

  return (
    <div ref={ref}>
      <SimpleQueueCard
        card={cardByItemId}
        isCheckboxSelected={isCheckboxSelected}
        isSortable={isSortable}
        setCheckboxSelected={setCheckboxSelected}
        queueItem={item}
        play={() => {
          trackPlayButtonClick?.();
          play();
        }}
      />
    </div>
  );
};
